import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorElearningTopicContentVm } from '../operator-elearning-topic-content-vm.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicContentsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopicContents`;
  }
  get(topicId?: number, search?: string, topicIds?: number[]): Observable<IOperatorElearningTopicContentVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (topicId !== undefined && topicId !== null) {
      params = params.set('topicId', topicId.toString());
    }
    if (search !== undefined && search !== null) {
      params = params.set('search', search);
    }
    if (topicIds !== undefined && topicIds !== null) {
      topicIds.forEach((id) => {
        params = params.append('topicIds', id.toString());
      });
    }
    return this.http.get<IOperatorElearningTopicContentVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
